import $ from 'jquery';
import BaseGateway from './BaseGateway';

class UniversalPaymentGateway extends BaseGateway {

    elementType = 'payment';

    paymentMethodType = '';

    constructor(props) {
        super(props);
        this.capabilities.push('place_order_button', 'checkout_error');
    }

    async mountPaymentElement(container) {
        this._elementsSubmitted = false;
        this.paymentElement.removeAllListeners();
        this.paymentElement.on('change', this.onPaymentElementChange.bind(this));
        this.paymentElement.on('loaderror', this.onLoadError.bind(this));

        this.paymentElement.mount(container);
    }

    onPaymentElementChange(event) {
        if (event?.value?.type) {
            this.paymentMethodType = event.value.type;
            $('#_stripe_payment_method_type').val(event.value.type);
        }
    }

    onLoadError() {

    }

    hasPaymentMethodId() {
        if (!['card', 'link', 'apple_pay', 'google_pay'].includes(this.paymentMethodType)) {
            return this._elementsSubmitted;
        }
        return super.hasPaymentMethodId();
    }

    shouldCreatePaymentMethod() {
        // only create a payment method on submit for card and link
        return ['card', 'link', 'apple_pay', 'google_pay'].includes(this.paymentMethodType);
    }

    buildPaymentElementOptions(isUpdate = false) {
        super.buildPaymentElementOptions();
        if (!isUpdate) {
            this._paymentElementOptions.wallets = {
                applePay: 'auto',
                googlePay: 'auto'
            };
        }
        return this._paymentElementOptions;
    }

}

export default UniversalPaymentGateway;